import { Component } from '@angular/core';
import { UiManagerService } from '../ui-manager.service';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent {
  constructor(public uiManagerService: UiManagerService) {}
}
